import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class HunspellSpellCheckService {
  private url: string = '/hunspell_spell_check';

  constructor(private httpClient: HttpClientService) {}

  addWord(word: string): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, { word: word });
  }

  delete(word: string): Promise<any> {
    return this.httpClient.delete(`${this.url}/0.json?word=${word}`);
  }

  index(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`);
  }

  suggestions(words: Array<string>): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, { words: words });
  }
}
